import {
  Box,
  Container,
  CssBaseline,
  Link,
  ThemeProvider,
  Toolbar,
  useMediaQuery,
} from "@mui/material";
import SignupForm from "./components/SignupForm";
import SignatureForm from "./components/SignatureForm";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { matjungelenTheme } from "./styles/matjungelenTheme";
import { StyledAppBar } from "./styles/styledComponents";
import { useEffect } from "react";
import { TRACKING_EVENTS } from "./services";

interface SignupFormAppProps {
  enhet?: string;
}

function MatjungelenAppBar() {
  const isSm = useMediaQuery("(max-width:700px)");

  return (
    <StyledAppBar position="static" color="transparent" elevation={0}>
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <img
            src="/images/logo.svg"
            alt="Matjungelen"
            style={{ width: "100%", maxWidth: "282px", height: "auto" }}
          />
          {!isSm && (
            <>
              <Box component="div" sx={{ flexGrow: 1 }}></Box>
              <Link
                href="https://www.matjungelen.no/"
                underline="always"
                sx={{
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: 1.5,
                  letterSpacing: 0,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <img
                  src="/arrow right-24.svg"
                  alt=""
                  width={24}
                  height={24}
                />{" "}
                Tilbake til matjungelen.no
              </Link>
            </>
          )}
        </Toolbar>
      </Container>
    </StyledAppBar>
  );
}

function SignupFormApp(props: SignupFormAppProps) {
  useEffect(() => {
    TRACKING_EVENTS.trackPageView(
      `/signup${props.enhet ? `/${props.enhet}` : "/"}`,
    );
  }, []);

  return (
    <>
      <CssBaseline />
      <MatjungelenAppBar />
      <Container component="main" maxWidth="lg" sx={{ mb: 4 }}>
        <div style={{ marginTop: 25 }}>
          <SignupForm enhet={props.enhet} />
        </div>
      </Container>
    </>
  );
}

function SignupApp() {
  const params = useParams();
  const { code } = params || {};

  useEffect(() => {
    TRACKING_EVENTS.trackPageView("/signature/");
  }, []);

  return (
    <>
      <CssBaseline />
      <MatjungelenAppBar />
      <Container
        component="main"
        maxWidth="lg"
        sx={{ mb: 4 }}
        className="matjungelen-content-wrapper"
      >
        <div style={{ marginTop: 100 }}>
          <SignatureForm code={code} />
        </div>
      </Container>
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={matjungelenTheme}>
      <BrowserRouter>
        <Routes>
          <Route path="/signature/:code?" element={<SignupApp />} />
          <Route
            path="/barnehage"
            element={<SignupFormApp enhet="barnehage" />}
          />
          <Route path="/sfo" element={<SignupFormApp enhet="sfo" />} />
          <Route path="*" element={<SignupFormApp />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
